import React from 'react';
import {
    Grid,
    Button,
    Dialog,
    DialogContent,
    useTheme,
    useMediaQuery
} from "@material-ui/core";
import DynamicInput from '../InputComponents/DynamicInput';
import services from '../../Services';
import { ConvertDate } from '../../helpers/textValidation';
const { employee } = services;

var moment = require('moment-timezone')

const CertificateModal = ({ certficateModall }) => {

    let { employeeDetails, open,
        close,
        certifcateadd, updateCertificate, setSelectedCertificateType,
        updatedCertificateExpiryDate,
        setUpdatedCertificateExpiryDate,
        certificateType,
        updatedCertificateIssueDate,
        selectedCertificateType,
        updatedCertificateID,
        setUpdatedCertificateIssueDate,
        updatedCertificateName, setUpdatedCertificateName, mainFlag, setMainFlag, setOpenC, setAddCertificate } = certficateModall;


    function onChangeCertificateDropDown(newValue) {
        {
            if(newValue) {
                const { id, name } = newValue;
                setSelectedCertificateType(id);
                setUpdatedCertificateName(name);
            }
            
        }

    }

    let fields = [

        { type: 1, name: "Certificate ID", initial: updateCertificate?.id, isDisabled: true },
        { type: 3, key: 'name', options: certificateType, name: "License Type", initial: certificateType[updateCertificate?.CertificateTypeId - 1], onChange: (newValue) => onChangeCertificateDropDown(newValue), isRequired: true },
        { type: 2, name: "Issue Date", initial: updatedCertificateIssueDate, onChange: setUpdatedCertificateIssueDate, isRequired: true },
        { type: 2, name: "Expire Date", initial: updatedCertificateExpiryDate, onChange: setUpdatedCertificateExpiryDate, isRequired: true },
    ]

    if (certifcateadd) {
        fields.splice(0, 1)

    }
    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    

    const handleCertificate = async (e) => {
        e.preventDefault();


        let data = {
            name: updatedCertificateName,
            type: selectedCertificateType,
            issue_date: ConvertDate(updatedCertificateIssueDate),
            expiry_date: ConvertDate(updatedCertificateExpiryDate),
            employee_id: employeeDetails?.id,
            id: updatedCertificateID
        }

        try {
            let result = null;
            if (certifcateadd)
                result = await employee.add_employee_certificate(data);
            else 
                result = await employee.update_employee_certificate(data)
            if (result.httpStatus == 200) {
                setMainFlag(!mainFlag)
                setOpenC(false);
                setAddCertificate(false)
            }
        }
        catch (exc) {
             
        }

    }

    
    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={close}
            className="BroadcastMessageModal LiqTables"
            aria-labelledby="responsive-dialog-title"
        >
            <Button autoFocus onClick={close} className="ModalClose">
            </Button>
            <form onSubmit={handleCertificate}>
                <DialogContent>
                    <DynamicInput fields={fields} />

                    <Grid xs={12} container justify="center" className="mt30">
                        <Button type="submit" className="LinkButton" >Save</Button>
                    </Grid>
                </DialogContent>
            </form>
        </Dialog>
    )
}

export default CertificateModal